import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Specialist } from "~/types/specialist";
import {
  initializeSpecialist,
  loginSpecialist,
  logoutSpecialist,
} from "./action";

type AuthState = {
  uid: string | null; // ユーザーID
  data: Specialist | null; // ユーザー情報（firestoreに保存されているデータ）
  login: boolean; // ログインしているかどうか
  isInit: boolean; // 初期化しているかどうか
  loading: boolean; // ロード中かどうか
  error?: { email?: string; password?: string } | null; // エラーメッセージ
};

const initialState: AuthState = {
  uid: null,
  data: null,
  login: false,
  isInit: false,
  loading: false,
};

const authModule = createSlice({
  name: "specialist/auth",
  initialState,
  reducers: {
    initialize(state) {
      state.isInit = false;
    },
    login(state, action: PayloadAction<string>) {
      state.uid = action.payload;
      state.login = true;
    },
  },
  extraReducers: (builder) => {
    // 初期化
    builder.addCase(initializeSpecialist.pending, (state) => {
      // 処理時
      return {
        ...state,
        uid: null,
        login: false,
        isInit: false,
      };
    });
    builder.addCase(initializeSpecialist.fulfilled, (state, action) => {
      // 成功時
      const payload = action.payload;
      if (payload) {
        return {
          ...state,
          uid: payload.uid,
          data: payload.data,
          login: true,
          isInit: true,
        };
      } else {
        return {
          ...state,
          login: false,
          isInit: true,
        };
      }
    });
    // ログイン処理
    builder.addCase(loginSpecialist.pending, (state) => {
      // 処理時
      return {
        ...state,
        user: null,
        login: false,
        loading: true,
        error: null,
      };
    });
    builder.addCase(loginSpecialist.rejected, (state, action) => {
      // 失敗時
      const errorMessage = action.payload?.message ?? "";
      const errorStatus = action.payload?.status ?? null;
      let error = null;
      switch (errorStatus) {
        case 0:
          error = {
            email: errorMessage,
            password: errorMessage,
          };
          break;
        case 1:
          error = {
            email: errorMessage,
          };
          break;
        case 2:
          error = {
            password: errorMessage,
          };
          break;
      }
      return {
        ...state,
        user: null,
        login: false,
        loading: false,
        error: error,
      };
    });
    builder.addCase(loginSpecialist.fulfilled, (state, action) => {
      // 成功時
      return {
        ...state,
        uid: action.payload,
        login: true,
        loading: false,
        error: null,
        isInit: false,
      };
    });
    // ログアウト処理
    builder.addCase(logoutSpecialist.pending, (state) => {
      // 処理時
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(logoutSpecialist.rejected, (state) => {
      // 失敗時
      return {
        ...state,
        loading: false,
      };
    });
    builder.addCase(logoutSpecialist.fulfilled, (state) => {
      // 成功時
      return {
        ...state,
        uid: null,
        login: false,
        loading: false,
      };
    });
  },
});

export const { initialize, login } = authModule.actions;
export {
  initializeSpecialist,
  loginSpecialist,
  logoutSpecialist,
} from "./action";

export default authModule;
